import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Spinner } from 'react-bootstrap';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { putAwayApi, grnApi } from 'api';

import paths from 'routes/paths';
import { getCreatePutAwayListColumns } from 'constants/putAway';

const CreatePutaway = () => {
  const navigate = useNavigate();

  const { selectedTenant, selectedWarehouse, loading } = useUserContext();

  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const handleCreatePutaway = useCallback(async selectedRows => {
    const grnIds = selectedRows.map(row => row.id);

    const response = await putAwayApi.create({
      grn_ids: grnIds,
    });

    return {
      result: response,
      shouldRefetch: false,
    };
  }, []);

  const bulkActions = [
    {
      value: 'create_putaway',
      label: 'Create Putaway',
      variant: 'primary',
      successMessage: 'Successfully create putaway',
      errorMessage: 'Fail to create putaway',
      handler: handleCreatePutaway,
      onSuccess: response => {
        const id = response?.result?.id;
        if (id != null) {
          navigate(paths.putAway.details(tenant, warehouse, id));
        }
      },
    },
  ];

  if (loading || !selectedWarehouse) {
    return (
      <Card className="d-flex justify-content-center align-items-center p-4">
        <Spinner animation="border" variant="primary" />
      </Card>
    );
  }

  return (
    <Table
      title="Create Putaway"
      apiService={grnApi}
      sortable={false}
      columns={getCreatePutAwayListColumns(tenant, warehouse)}
      bulkActions={bulkActions}
      fetchConfig={{
        method: 'getGRNPutaway',
      }}
      resourceId={selectedWarehouse?.id}
    />
  );
};

export default CreatePutaway;
